import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "paper-layout"
};
const _hoisted_2 = {
  class: "paper-box"
};
const _hoisted_3 = {
  class: "paper-content"
};
const _hoisted_4 = {
  class: "paper-toolbar"
};
const _hoisted_5 = {
  key: 0,
  class: "paper-header"
};
const _hoisted_6 = {
  key: 1,
  class: "paper-search-box"
};
const _hoisted_7 = {
  class: "paper-detail"
};
import XToolbar from '@/components/xtoolbar/xToolbar.vue';
import { computed } from 'vue';
export default {
  __name: 'xPaperLayout',
  props: {
    toolbar: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      default: ''
    }
  },
  emits: ['toolbar-item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const toolbarItems = computed(() => props.toolbar);
    const emit = __emit;
    const handleToolbarItemClick = item => {
      emit('toolbar-item-click', item);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "toolbar", {}, () => [_createVNode(XToolbar, {
        items: toolbarItems.value,
        onItemClick: handleToolbarItemClick
      }, null, 8, ["items"])])]), _ctx.$slots.header ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_renderSlot(_ctx.$slots, "header")])) : _createCommentVNode("", true), _ctx.$slots.searchbar ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_renderSlot(_ctx.$slots, "searchbar")])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [_renderSlot(_ctx.$slots, "default")])])])]);
    };
  }
};